var _baseUrl = "https://localhost:5001/";

export let baseUrl = _baseUrl;
baseUrl = process.env.VUE_APP_ENDPOINT;